import { GRID_ID_AUTOGENERATED } from '@mui/x-data-grid/internals'
import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium'

// Rows the grid generates itself (client-side grouping groups, aggregation footers, lazy-loading
// skeletons) reach `valueGetter` as a stub carrying no data fields, so any getter that reads past a
// plain field would throw.
export const skipValueGetterOnAutogeneratedRows = <R extends GridValidRowModel>(column: GridColDef<R>): GridColDef<R> => {
  const { valueGetter } = column
  if (valueGetter === undefined) return column

  return {
    ...column,
    valueGetter: (value, row, columnDef, apiRef) =>
      GRID_ID_AUTOGENERATED in row ? undefined : valueGetter(value, row, columnDef, apiRef),
  }
}
